import ServerInstance from "./server.api";

class RentingEndpoint extends ServerInstance {
    async getRenting() {
        try {
            const response = await this.get("rent");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getRequest() {
        try {
            const response = await this.get("request");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async deleteRequest(id) {
        try {
            const response = await this.delete(`request/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async verifyRequest(id) {
        try {
            const response = await this.patch(`request/verify/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getRentingById(id) {
        try {
            const response = await this.get(`rent/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async createRenting(formData) {
        try {
            const response = await this.post("request", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async extendRenting(formData) {
        console.log(formData);

        try {
            const response = await this.post("request/extend", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async payRent(trxiD) {
        try {
            const response = await this.patch(`rent/verify/${trxiD}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async checkInOut(id, status) {
        try {
            const response = await this.post(`rent/check/${id}`, {
                status: status
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getUtilitiesInvoice() {
        try {
            const responseWater = await this.get("water")
            const responseelectricity = await this.get("electricity")

            return {

                waterInvocie: responseWater.data.sent_water_invocie,
                electricityInvocie: responseelectricity.data.sent_electricity_invocie,

            }
        } catch (error) {
            throw error
        }
    }

    async addUtilityInvoice(formData, type) {
        try {
            const endpoint = type === 'water' ? 'water' : 'electricity';
            const response = await this.post(endpoint, formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default RentingEndpoint;
